// extracted by mini-css-extract-plugin
export default {"root":"FavoritesPage_root__VppTs","listingCards":"FavoritesPage_listingCards__7iWVJ","listingCard":"FavoritesPage_listingCard__YDXCL"};